<template>
  <el-dialog
    :visible="true"
    :before-close="handleClose"
    :title="'核素设置' | translateTo(i18nPath)"
    width="55vw"
    class="rg05-setting"
  >
    <el-scrollbar wrap-style="height: 60vh;" element-loading-background="rgba(0, 0, 0, 0.8)">
      <el-form
        ref="form"
        v-loading="loading"
        :element-loading-text="'{loading}...' | translateTo('common')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :model="data"
        :rules="rules"
        label-width="180px"
        :inline="true"
      >
        <el-row style="width: 100%" type="flex" v-for="(e, i) in data" :key="i">
          <el-col :span="24">
            <el-divider content-position="left">
              {{ nuclideDict[i] | translateTo(i18nPath) }}
            </el-divider>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="'是否开启蜂鸣器' | translateTo(i18nPath)"
              prop="naturalNuclideBuzzer"
            >
              <el-radio-group v-model="e[0]">
                <el-radio
                  v-for="(item, index) in buzzOptions"
                  :key="`alarm-${index}`"
                  :label="item.value"
                >
                  {{ item.label | translateTo(i18nPath) }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'LED灯光-正常' | translateTo(i18nPath)" prop="setColorPlan">
              <el-color-picker
                size="small"
                :value="`rgb(${e[1]},${e[2]},${e[3]}}}})`"
                @change="handleColorChange(e, $event)"
              ></el-color-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-divider content-position="left">
              {{ nuclideRunParam.title | translateTo(i18nPath) }}
            </el-divider>
          </el-col>
          <el-col
            :span="24"
            v-for="(item, index) in nuclideRunParam.options"
            :key="`params-${index}`"
          >
            <el-form-item
              :label="item.label | translateTo(i18nPath)"
              :label-width="isEnglish ? '400px' : ''"
              :prop="item.prop"
            >
              <el-radio-group
                v-model="nuclideRunParam.model[item.prop]"
                v-if="item.type === 'radioGroup'"
              >
                <el-radio
                  v-for="(item, index) in item.props.options"
                  :key="`data-${index}`"
                  :label="item.value"
                >
                  {{ item.label | translateTo(i18nPath) }}
                </el-radio>
              </el-radio-group>

              <el-input v-else v-model="nuclideRunParam.model[item.prop]">
                <template slot="append">{{ item.props.suffix }}</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-scrollbar>

    <div class="handler">
      <el-button
        class="confirm"
        type="primary"
        :disabled="loading"
        :loading="confirmLoading"
        @click="save"
      >
        {{ 'confirm' | translateTo }}
      </el-button>
      <el-button class="cancel" @click="handleClose">
        {{ 'cancel' | translateTo }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import Color from 'color';

import { getNuclideAlarmConfig, setNuclideAlarmConfig } from '@/api/deviceSetting';
import { isEmpty, isFunction, isString } from '@/utils/is';
// import { List } from '@/utils/List';
import { awaitTo } from '@/utils/utils';
import { translateTo } from '@/utils/locale';

var makeValidate = ({ min, max, msg }) => {
  const validator = (_, value, callback) => {
    if (value >= min && value <= max) {
      callback();
    } else {
      callback(new Error(isString(msg) ? msg : msg()));
    }
  };
  return { validator };
};

const common = {
  message: '请输入数值',
  validator(rule, value, callback) {
    if (/^\d+$/.test(value)) {
      callback();
    } else {
      callback(new Error(rule.message));
    }
  },
  trigger: 'blur'
};

export default {
  props: {
    sn: {
      type: String,
      default: ''
    },
    deviceType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      i18nPath: 'layout',
      loading: false,
      confirmLoading: false,
      oldData: {},
      hwVer: '',
      swVer: '',
      wifiConnectionStatus: 0,
      connection4GStatus: 1,
      simNumber: '89860622330053003208',
      buzzOptions: [
        { label: '关闭', value: 0 },
        { label: '开启', value: 1 }
      ],
      nuclideDict: ['天然核素', '工业核素', '医用核素', '特殊核材料核素'],
      data: {
        0: [0, 23, 44, 55],
        1: [0, 23, 44, 55],
        2: [0, 23, 44, 55],
        3: [0, 33, 44, 56]
      },
      rules: {
        setAlarmThresh: [
          {
            validator: (_, value, callback) => {
              const reg = /^0|1000$|^[1-9]\d{0,2}$|^(?:0\.\d|[1-9]\d{0,2}\.\d)$/;
              const reg2 = /^(0|1000|([1-9]\d{0,2}))$/;
              if (this.swVer && !reg2.test(value)) {
                let lastIndex = this.swVer.lastIndexOf('.');
                let subVer = this.swVer.slice(lastIndex + 1);
                if (lastIndex === 1 && subVer < 11) {
                  callback(
                    new Error(translateTo('合法数值整数校验模板', 'device', { min: 0, max: 1000 }))
                  );
                } else {
                  callback();
                }
              } else if (!reg.test(value)) {
                callback(
                  new Error(
                    translateTo('合法数值浮点数校验模板', 'device', {
                      min: 0,
                      max: 1000,
                      precision: 1
                    })
                  )
                );
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
          makeValidate({
            min: 0,
            max: 1000,
            msg: () => translateTo('请正确填写报警阈值', 'device')
          })
        ],
        setBuzzVol: [
          common,
          makeValidate({ min: 0, max: 3, msg: () => translateTo('请正确填写蜂鸣器音量', 'device') })
        ],
        setGratingMode: [
          common,
          makeValidate({
            min: 0,
            max: 65536,
            msg: () => translateTo('请选择光栅主从模式', 'device')
          })
        ],
        setDeviceAlarmMode: [
          common,
          makeValidate({
            min: 100,
            max: 240,
            msg: () => translateTo('请设置设备报警状态', 'device')
          })
        ],
        setAlarmSmooth: [
          makeValidate({
            min: 0,
            max: 10,
            msg: () => translateTo('报警平滑时长设置范围模板', 'device', { min: 0, max: 10 })
          })
        ]
      },
      nuclideRunParam: {
        title: '核素识别运行参',
        prop: 'nuclideRunParamMap',
        model: {
          energySpectrumSwitch: 1,
          measurementTime: 0,
          updateTime: 0,
          recognitionTime: 0,
          recognitionCycle: 0,
          triggerThreshold: 0
        },
        options: [
          {
            label: '是否能上传能谱数据',
            prop: 'energySpectrumSwitch',
            type: 'radioGroup',
            props: {
              options: [
                { label: '关闭', value: 0 },
                { label: '开启', value: 1 }
              ]
            }
          },
          { label: '测试时间', prop: 'measurementTime', props: { suffix: '秒' } },
          { label: '更新时间', prop: 'updateTime', props: { suffix: '秒' } },
          { label: '识别时间', prop: 'recognitionTime', props: { suffix: '秒' } },
          { label: '识别周期', prop: 'recognitionCycle', props: { suffix: '秒' } },
          { label: '触发阈值', prop: 'triggerThreshold', props: { suffix: '秒' } }
        ]
      }
    };
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      isFunction(done) && done();
    },
    clearLoading() {
      const timer = setTimeout(() => {
        this.loading = false;
        this.confirmLoading = false;
        clearTimeout(timer);
      }, 500);
    },
    getDeviceStatus() {
      this.loading = true;
      getNuclideAlarmConfig({ sn: this.sn, deviceType: this.deviceType })
        .then(res => {
          const { nuclideAlarmConfig, nuclideRunParamMap } = res.data;

          if (!isEmpty(nuclideAlarmConfig)) {
            for (let e in nuclideAlarmConfig) {
              const arr = nuclideAlarmConfig[e].split(',');
              this.data[e].splice(0, Infinity, ...arr.slice(1).map(e => +e));
            }
          }

          if (!isEmpty(nuclideRunParamMap)) {
            Object.assign(this.nuclideRunParam.model, nuclideRunParamMap);
          }
        })
        .finally(this.clearLoading);
    },
    handleColorChange(item, event) {
      item.splice(1, 3, ...Color(event).array());
    },
    getParams() {
      const res = [];
      for (let e in this.data) {
        res.push(e, ...this.data[e]);
      }

      const nuclideRunParamMap = this.nuclideRunParam.model;

      return { setNuclideAlarmConfig: res.join(','), nuclideRunParamMap };
    },
    async save() {
      this.confirmLoading = true;

      const [err] = await awaitTo(this.$refs.form.validate());
      if (err === false) return (this.confirmLoading = false);

      const params = this.getParams();

      if (isEmpty(params)) {
        console.log('[RG05][SETTING]--无参数');
        this.clearLoading();
        this.handleClose();
        return;
      }

      setNuclideAlarmConfig({
        sn: this.sn,
        deviceType: this.deviceType,
        requestData: params
      })
        .then(() => {
          this.$message.success('设置成功');
          this.handleClose();
        })
        .finally(this.clearLoading);
    }
  },
  created() {
    this.getDeviceStatus();
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.rg05-setting {
  .el-dialog {
    min-width: 900px;
  }

  .iconfont {
    color: #eee;
    margin-right: 10px;
    &.active {
      color: #2bff01;
    }
  }

  .el-row {
    &.el-row--flex {
      flex-wrap: wrap;
    }
    .el-col {
      overflow: hidden;
    }
  }

  .el-form {
    display: block;
    .el-form-item {
      display: flex;
      .el-form-item__label {
        &::after {
          content: '：';
        }
      }
      .el-form-item__content {
        flex: 1;
        display: flex;
        align-items: center;
        .el-input {
          width: 230px;
        }
        .unit {
          margin-left: 20px;
        }
      }
    }
    .el-slider {
      width: 90%;
      padding-left: 5px;
    }
    .handler {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      .confirm {
        margin-right: 20px;
      }
    }
  }
}
</style>
